/* eslint-disable jsx-a11y/no-autofocus */
var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import InputModal from '@pcln/input-modal';
import React, { memo, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box, Button, Flex, Grid, ShadowOverlay, Text, Tooltip, getPaletteColor } from 'pcln-design-system';
import { User as UserIcon, ArrowLeft as LeftIcon } from 'pcln-icons';
import Popover from 'pcln-popover';
import TravelerSelectionContent from '../TravelerSelectionContent';
import useTravelerSelection from '../useTravelerSelection';
import { DEFAULT_MAX_TRAVELERS } from '../constants';
var Container = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "TravelerSelection__Container",
  componentId: "sc-ntt12-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  height: ", "px;\n\n  & > :last-child {\n    width: 100%;\n    ", ";\n  }\n"], ["\n  position: relative;\n  height: ", "px;\n\n  & > :last-child {\n    width: 100%;\n    ", ";\n  }\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.isOpen ? 'z-index: 1502' : '';
});
var StyledPopover = /*#__PURE__*/styled(Popover).withConfig({
  displayName: "TravelerSelection__StyledPopover",
  componentId: "sc-ntt12-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  max-width: 388px;\n"], ["\n  position: relative;\n  max-width: 388px;\n"])));
var TravelerSelectionButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "TravelerSelection__TravelerSelectionButton",
  componentId: "sc-ntt12-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &&& {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    font-size: ", "px;\n    font-weight: normal;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    outline: none;\n\n    &:focus {\n      border: 1px solid ", ";\n      box-shadow: 0 0 0 2px ", ";\n    }\n\n    & > * {\n      width: 100%;\n    }\n\n    ", " {\n      font-size: ", "px;\n    }\n  }\n"], ["\n  &&& {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    font-size: ", "px;\n    font-weight: normal;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    outline: none;\n\n    &:focus {\n      border: 1px solid ", ";\n      box-shadow: 0 0 0 2px ", ";\n    }\n\n    & > * {\n      width: 100%;\n    }\n\n    ", " {\n      font-size: ", "px;\n    }\n  }\n"])), themeGet('fontSizes.2'), function (props) {
  return props.hasError ? getPaletteColor('error.base')(props) : getPaletteColor('border.base')(props);
}, getPaletteColor('primary.base'), getPaletteColor('primary.base'), themeGet('mediaQueries.lg'), themeGet('fontSizes.1'));
var StyledTooltip = /*#__PURE__*/styled(Tooltip).withConfig({
  displayName: "TravelerSelection__StyledTooltip",
  componentId: "sc-ntt12-3"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  top: ", "px;\n  z-index: 2;\n\n  &::after {\n    &:focus {\n      outline: none;\n    }\n  }\n"], ["\n  top: ", "px;\n  z-index: 2;\n\n  &::after {\n    &:focus {\n      outline: none;\n    }\n  }\n"])), function (props) {
  return props.errorHeight;
});
var StyledBackButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "TravelerSelection__StyledBackButton",
  componentId: "sc-ntt12-4"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  z-index: 1502;\n"], ["\n  z-index: 1502;\n"
/** @public */])));
/** @public */
var TravelerSelection = function (_a) {
  var ageSelectEnabled = _a.ageSelectEnabled,
    _b = _a.borderRadius,
    borderRadius = _b === void 0 ? 'lg' : _b,
    className = _a.className,
    disclaimer = _a.disclaimer,
    errorMessage = _a.errorMessage,
    _c = _a.fireChildCountImpression,
    fireChildCountImpression = _c === void 0 ? function () {} : _c,
    hasShadowEffect = _a.hasShadowEffect,
    _d = _a.height,
    height = _d === void 0 ? 42 : _d,
    initialValues = _a.initialValues,
    isInternationalFlight = _a.isInternationalFlight,
    _e = _a.isHotel,
    isHotel = _e === void 0 ? false : _e,
    _f = _a.isMobile,
    isMobile = _f === void 0 ? false : _f,
    isTravelerSelectionDisabled = _a.isTravelerSelectionDisabled,
    isWhiteLabel = _a.isWhiteLabel,
    lapInfantLabel = _a.lapInfantLabel,
    maxAdults = _a.maxAdults,
    maxChildren = _a.maxChildren,
    maxRooms = _a.maxRooms,
    maxRoomsMessage = _a.maxRoomsMessage,
    maxRoomsUrl = _a.maxRoomsUrl,
    fireMaxRoomsOnClick = _a.fireMaxRoomsOnClick,
    _g = _a.maxTravelers,
    maxTravelers = _g === void 0 ? DEFAULT_MAX_TRAVELERS : _g,
    onChange = _a.onChange,
    roomsEnabled = _a.roomsEnabled,
    shouldCountLapInfant = _a.shouldCountLapInfant,
    _h = _a.showBackButton,
    showBackButton = _h === void 0 ? false : _h,
    subLabelMap = _a.subLabelMap,
    _j = _a.tooltipErrorMessageId,
    tooltipErrorMessageId = _j === void 0 ? 'traveler-selection-tooltip-error' : _j,
    _k = _a.trapFocus,
    trapFocus = _k === void 0 ? true : _k,
    _l = _a.usePopoverPortal,
    usePopoverPortal = _l === void 0 ? false : _l,
    _m = _a.errorHeight,
    errorHeight = _m === void 0 ? 20 : _m,
    props = __rest(_a, ["ageSelectEnabled", "borderRadius", "className", "disclaimer", "errorMessage", "fireChildCountImpression", "hasShadowEffect", "height", "initialValues", "isInternationalFlight", "isHotel", "isMobile", "isTravelerSelectionDisabled", "isWhiteLabel", "lapInfantLabel", "maxAdults", "maxChildren", "maxRooms", "maxRoomsMessage", "maxRoomsUrl", "fireMaxRoomsOnClick", "maxTravelers", "onChange", "roomsEnabled", "shouldCountLapInfant", "showBackButton", "subLabelMap", "tooltipErrorMessageId", "trapFocus", "usePopoverPortal", "errorHeight"]);
  var useTravelerSelectionProps = useMemo(function () {
    return {
      initialValues: __assign({
        rooms: roomsEnabled ? 1 : 0
      }, initialValues),
      ageSelectEnabled: !!ageSelectEnabled,
      errorMessage: errorMessage,
      isInternationalFlight: !!isInternationalFlight,
      isWhiteLabel: isWhiteLabel,
      maxTravelers: maxTravelers,
      shouldCountLapInfant: shouldCountLapInfant
    };
  }, [errorMessage, initialValues, roomsEnabled]);
  var _o = useState(false),
    isOpen = _o[0],
    setOpen = _o[1];
  var state = useTravelerSelection(useTravelerSelectionProps);
  var modalIdx = 'traveler-selection-modal';
  var popoverIdx = 'traveler-selection-popover';
  var selectorAriaLabel = 'Select traveler information';
  useEffect(function () {
    if (!isOpen) return;
    if (!isMobile) {
      var selectTravelerBtn_1 = document.querySelector("[aria-label=\"".concat(selectorAriaLabel, "\"]"));
      var popoverMenuBtn_1 = document.querySelector("[aria-describedby=\"dialog-description-".concat(popoverIdx, "\"]"));
      var popoverMenu_1 = document.querySelector("[aria-describedby=\"dialog-description-".concat(popoverIdx, "\"] > div"));
      popoverMenu_1.style.opacity = '0';
      setTimeout(function () {
        var btnTop = selectTravelerBtn_1.getBoundingClientRect().top;
        var _a = popoverMenu_1.getBoundingClientRect(),
          menuBottom = _a.bottom,
          menuHeight = _a.height;
        var isTopPlacement = popoverMenuBtn_1.attributes['data-placement'] === 'top';
        var currentTopValue;
        var newTopValue;
        if (menuBottom > window.innerHeight) {
          currentTopValue = parseInt(popoverMenu_1.style.top.replace(/^\D+/g, '')) || 0;
          /* c8 ignore next */
          newTopValue = isTopPlacement ? currentTopValue - menuHeight : Math.max(btnTop - menuHeight - 30, 0);
        } else {
          currentTopValue = parseInt(popoverMenuBtn_1.style.top.replace(/^\D+/g, '')) || 0;
          /* c8 ignore next */
          newTopValue = isTopPlacement ? currentTopValue - menuHeight : currentTopValue - 8;
        }
        popoverMenuBtn_1.style.top = newTopValue + 'px';
        popoverMenu_1.style.opacity = '1';
      }, 10);
    }
  }, [isOpen]);
  var popoverPortal = 'traveler-selection-popover-place';
  useEffect(function () {
    var rooms = roomsEnabled ? useTravelerSelectionProps.initialValues.rooms || 1 : 0;
    state.setRooms(rooms);
    if (onChange) {
      onChange(__assign(__assign({}, state), {
        rooms: rooms
      }));
    }
  }, [roomsEnabled, useTravelerSelectionProps.initialValues.rooms]);
  if (state.children && isOpen && fireChildCountImpression) {
    fireChildCountImpression();
  }
  function onOpen() {
    setOpen(true);
  }
  function onClose() {
    setOpen(false);
    /* istanbul ignore else */
    if (onChange) {
      onChange(state);
    }
  }
  function PopoverContent(_a) {
    var handleClose = _a.handleClose;
    return React.createElement(TravelerSelectionContent, {
      ageSelectEnabled: ageSelectEnabled,
      autoFocus: trapFocus,
      disclaimer: disclaimer,
      handleClose: handleClose,
      isHotel: isHotel,
      isPopover: !isMobile,
      lapInfantLabel: lapInfantLabel,
      maxAdults: maxAdults,
      maxChildren: maxChildren,
      maxRooms: maxRooms,
      fireMaxRoomsOnClick: fireMaxRoomsOnClick,
      maxRoomsMessage: maxRoomsMessage,
      maxRoomsUrl: maxRoomsUrl,
      roomsEnabled: roomsEnabled,
      shouldCountLapInfant: shouldCountLapInfant,
      state: state,
      subLabelMap: subLabelMap
    });
  }
  return React.createElement(React.Fragment, null, React.createElement(Container, __assign({
    className: className,
    isOpen: isOpen,
    width: 1,
    height: height
  }, props), !isMobile && React.createElement(React.Fragment, null, hasShadowEffect && isOpen && React.createElement(ShadowOverlay, {
    onClick: onClose,
    "data-testid": 'traveler-selection-overlay',
    zIndex: 1501
  }), React.createElement(StyledPopover, {
    idx: popoverIdx,
    hideArrow: true,
    trapFocus: trapFocus,
    ariaLabel: selectorAriaLabel,
    width: '388px',
    height: height,
    zIndex: 1502,
    placement: 'bottom',
    renderContent: PopoverContent,
    onOpen: onOpen,
    onClose: onClose,
    querySelectorPortal: ".".concat(popoverPortal)
  }, React.createElement(TravelerSelectionButton, {
    isOpen: isOpen,
    hasError: state.errorMessage && !isOpen,
    "aria-invalid": state.errorMessage ? 'true' : 'false',
    "aria-errormessage": state.errorMessage ? tooltipErrorMessageId : undefined,
    color: 'background.lightest',
    width: 1,
    p: 2,
    pl: isOpen && showBackButton && 0,
    disabled: isTravelerSelectionDisabled,
    borderRadius: borderRadius,
    onClick: onOpen
  }, isOpen && showBackButton && React.createElement(StyledBackButton, {
    color: 'primary',
    onClick: onClose,
    size: 'small',
    "data-testid": 'traveler-back-button',
    mr: 2
  }, React.createElement(LeftIcon, {
    color: 'white'
  })), React.createElement(Flex, {
    alignItems: 'center',
    width: 1
  }, React.createElement(UserIcon, {
    color: 'primary',
    mr: 2
  }), state.label), !isOpen && state.errorMessage && React.createElement(StyledTooltip, {
    errorHeight: errorHeight,
    id: tooltipErrorMessageId,
    width: 250,
    color: 'error',
    role: 'alert',
    right: true,
    bottom: true
  }, state.errorMessage)))), isMobile && React.createElement(React.Fragment, null, React.createElement(TravelerSelectionButton, {
    type: 'button',
    color: 'background.lightest',
    width: 1,
    p: 2,
    disabled: isTravelerSelectionDisabled,
    borderRadius: borderRadius,
    onClick: onOpen,
    "aria-invalid": state.errorMessage ? 'true' : 'false',
    "aria-errormessage": state.errorMessage ? tooltipErrorMessageId : undefined
  }, React.createElement(Flex, {
    alignItems: 'center',
    width: 1
  }, React.createElement(UserIcon, {
    color: 'primary',
    mr: 2
  }), state.label), !isOpen && state.errorMessage && React.createElement(StyledTooltip, {
    id: tooltipErrorMessageId,
    width: 250,
    color: 'error',
    role: 'alert',
    right: true,
    bottom: true
  }, state.errorMessage)), React.createElement(InputModal, {
    id: modalIdx,
    footer: React.createElement(Button, {
      type: 'button',
      borderRadius: 'lg',
      onClick: onClose
    }, "Done"),
    input: React.createElement(Grid, {
      alignItems: 'center',
      templateColumns: '1fr auto',
      pb: 2
    }, React.createElement(Flex, {
      justifyContent: 'center'
    }, React.createElement(Text, {
      fontSize: '3',
      fontWeight: 'bold',
      color: 'primary.dark'
    }, "Travelers")), React.createElement(Box, {
      width: '40px',
      height: '40px',
      ml: '12px'
    })),
    inputProps: {
      px: 2,
      py: 2
    },
    isOpen: isOpen,
    subheading: React.createElement(Flex, {
      justifyContent: 'center',
      width: 1
    }, React.createElement(Text, {
      fontSize: '2',
      fontWeight: 'medium',
      color: 'text',
      mb: 2
    }, state.label)),
    zIndex: 1502,
    onClose: onClose
  }, React.createElement(TravelerSelectionContent, {
    ageSelectEnabled: ageSelectEnabled,
    autoFocus: trapFocus,
    disclaimer: disclaimer,
    handleClose: onClose,
    isHotel: isHotel,
    lapInfantLabel: lapInfantLabel,
    maxAdults: maxAdults,
    maxChildren: maxChildren,
    maxRooms: maxRooms,
    maxRoomsMessage: maxRoomsMessage,
    maxRoomsUrl: maxRoomsUrl,
    roomsEnabled: roomsEnabled,
    shouldCountLapInfant: shouldCountLapInfant,
    state: state,
    subLabelMap: subLabelMap,
    fireMaxRoomsOnClick: fireMaxRoomsOnClick
  })))), usePopoverPortal ? React.createElement(Box, {
    className: popoverPortal,
    width: 0,
    "data-testid": 'popover-portal'
  }) : null);
};
export default memo(TravelerSelection);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;